import { render, staticRenderFns } from "./GpList.vue?vue&type=template&id=7402c890&"
import script from "./GpList.vue?vue&type=script&lang=js&"
export * from "./GpList.vue?vue&type=script&lang=js&"
import style0 from "./GpList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports